module.exports = __webpack_public_path__ + "img/cp-library-info.f4ef30ce.svg";